import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-p00058-speed-choice',
  templateUrl: './p00058-speed-choice.component.html',
  styleUrls: ['./p00058-speed-choice.component.scss'],
  imports: [
    IonButton,
    IonContent,
    IonFooter,
    IonItem,
    IonLabel,
    IonList,
    TranslatePipe,
  ],
})
export class P00058SpeedChoiceComponent {
  private modalController = inject(ModalController);

  @Input() value: number = 0;
  constructor() {}

  async select(value: number) {
    await this.modalController.dismiss({ value: value });
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss();
  }
}
